import Marquee from "react-fast-marquee";

const industries = [
  "Handwerker", "Friseure", "Tätowierer", "Ärzte", "Physiotherapeuten",
  "Restaurants", "Cafés", "Immobilienmakler", "Fitnessstudios", "Kosmetikstudios",
  "Anwälte", "Bäckereien",
];

export default function IndustryMarquee() {
  return (
    <section className="py-10 border-y border-[#E4E4E7] bg-[#F8F9FA]" aria-label="Branchen">
      <p className="text-center font-mono text-[10px] uppercase tracking-[0.3em] text-[#A1A1AA] mb-5">
        Webseiten für Betriebe wie deinen
      </p>
      <div className="marquee-mask">
        <Marquee speed={30} gradient={false} pauseOnHover autoFill>
          {industries.map((name) => (
            <span key={name} className="flex items-center mx-6">
              <span className="font-display text-lg md:text-xl text-[#52525B]">{name}</span>
              <span className="ml-12 w-1.5 h-1.5 rounded-full bg-[#2563EB]" aria-hidden="true" />
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
